import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const NotFoundPage = () => (
  <div>
    <Navbar />
    <main className="container text-center" style={{ minHeight: '65vh', paddingTop: '9rem', paddingBottom: '4rem' }}>
      <p style={{ color: 'var(--accent)', fontWeight: 700, letterSpacing: '0.08em' }}>404</p>
      <h1 style={{ margin: '0.75rem 0 1rem' }}>Page Not Found</h1>
      <p style={{ color: 'var(--muted-foreground)', fontSize: '1.125rem', margin: '0 auto 2rem', maxWidth: '560px' }}>
        The page you are looking for is unavailable or may have moved.
      </p>
      <Link to="/" className="btn-primary">Return to Home</Link>
    </main>
    <Footer />
  </div>
);

export default NotFoundPage;
